"use strict";

(function () {
  'use strict';

  angular.module('lr.card', []).component('lrCard', {
    bindings: {
      size: '@'
    },
    controller: lrCardCtrl,
    transclude: {
      title: '?cardTitle',
      action: '?cardAction',
      content: '?cardContent'
    },
    templateUrl: 'components/lr.card/lr.card.html'
  });
  lrCardCtrl.$inject = ['$element', '$transclude'];
  /* @ngInject */

  function lrCardCtrl($element, $transclude) {
    var vm = this;

    this.$onInit = function () {
      var _sizes = {
        xs: 'lr-card-xs',
        sm: 'lr-card-sm',
        md: 'lr-card-md',
        lg: 'lr-card-lg'
      };

      if (_sizes.hasOwnProperty(vm.size)) {
        $element.children('.lr-card').addClass(_sizes[this.size]);
      }
    };

    this.isTranscluded = function (slotName) {
      return $transclude.isSlotFilled(slotName);
    };
  }
})();